import type { CreateConfluenceDraftV2Response } from '../services/confluence-rest-api/types';

export const getDraftShareId = (uri?: string) => {
	if (!uri || uri === '') return '';
	const matches = uri.match(/draftShareId=([^&])*/g);

	return matches ? matches[0].split('=')[1] : '';
};

export const convertUrlSpaceIdToSpaceKey = ({
	url,
	spaceId,
	spaceKey,
}: {
	url?: string;
	spaceId?: string;
	spaceKey?: string;
}) => {
	if (!(url && spaceId && spaceKey)) return undefined;
	return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};

export const getURLFromConfluencePageResponse = ({
	data,
	spaceKey,
	hostname,
}: {
	data: CreateConfluenceDraftV2Response;
	spaceKey: string;
	hostname?: string;
}) => {
	// In case something went wrong but is not an error
	if (!data.id || !data.spaceId) {
		return '';
	}

	let domain = '';
	if (typeof window.location !== 'undefined') {
		domain = hostname ?? window.location.origin;
	}

	// Success:: build and return URL from the response data
	return `${domain}/wiki/spaces/${spaceKey}/pages/edit-v2/${data.id}/`;
};
